<template>
  <ContainerWrapper>
    <OffersList v-if="cptdDisplayAffiliates" title="PIX parcelado">
      <KoinOfferCardContainer v-if="cptdDisplayKoin" key="KOIN" />
    </OffersList>
  </ContainerWrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import { isDateGreaterThan, isDateLowerThan, localDate } from '@/helpers/date'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import KoinOfferCardContainer from '~/containers/loans/pix/offer/affiliates/koin/KoinOfferCardContainer.vue'
export default {
  name: 'PixOffersListContainer',
  components: {
    KoinOfferCardContainer,
    ContainerWrapper,
    OffersList,
  },
  computed: {
    ...mapGetters({
      personaData: 'user/persona/personaData',
      gtAllProposedNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllProposedNoCollateralOffers',
      gtNoCollateralLatestSimulationRequest:
        'products/loans/no-collateral/no-collateral/gtNoCollateralLatestSimulationRequest',
      gtAutoColdOffers:
        'products/loans/auto-equity/cold-offer/gtAutoColdOffers',
      gtAllValidatingAutoOffers:
        'products/loans/auto-equity/auto-equity/gtAllValidatingAutoOffers',
      gtAllProposedAutoOffers:
        'products/loans/auto-equity/auto-equity/gtAllProposedAutoOffers',
      gtAutoEquityLatestColdOfferRequest:
        'products/loans/auto-equity/cold-offer/gtAutoEquityLatestColdOfferRequest',
      gtAllOngoingFgtsOffers: 'products/loans/fgts/gtAllOngoingFgtsOffers',
      gtFgtsLastSimulationDate: 'products/loans/fgts/gtFgtsLastSimulationDate',
    }),
    cptdIsRejectedInNoCollateral() {
      return (
        this.gtAllProposedNoCollateralOffers.length === 0 &&
        this.gtNoCollateralLatestSimulationRequest?.created &&
        isDateGreaterThan(
          localDate(this.gtNoCollateralLatestSimulationRequest?.created),
          new Date(Date.now() - 24 * 60 * 60 * 1000 * 30),
        )
      )
    },
    cptdIsRejectedOnAutoEquity() {
      return (
        (this.cptdHasNoAutoOffers &&
          !Object.keys(this.gtAutoEquityLatestColdOfferRequest || {}).length) ||
        (this.gtAutoEquityLatestColdOfferRequest?.created &&
          isDateLowerThan(
            localDate(this.gtAutoEquityLatestColdOfferRequest?.created),
            new Date(Date.now() - 24 * 60 * 60 * 1000 * 30),
          ))
      )
    },
    cptdHasNoAutoOffers() {
      return (
        this.gtAllProposedAutoOffers.length === 0 &&
        this.gtAllValidatingAutoOffers.length === 0 &&
        this.gtAutoColdOffers.length === 0
      )
    },
    cptdDisplayAffiliates() {
      return this.cptdDisplayKoin
    },
    cptdDisplayKoin() {
      const disabled = true
      if (disabled) return false
      return (
        this.cptdIsRejectedOnAutoEquity && this.cptdIsRejectedInNoCollateral
      )
    },
  },
}
</script>
<style lang="scss"></style>
